import React from 'react';
import { motion } from 'framer-motion';

const itemVariants = {
  hidden: { opacity: 0, y: 40 }, // Menor desplazamiento inicial
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 90, // Menos rigidez
      damping: 18 // Menos amortiguación
    }
  },
};

const SectionTitle = ({ title, subtitle }) => (
  <motion.div
    className="section-title"
    variants={itemVariants}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.5 }} // Ajuste del viewport
  >
    <h2>{title}</h2>
    <p>{subtitle}</p>
  </motion.div>
);

export default SectionTitle;